import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderLocation extends Layout {
	sourceLocationLookup: DataSource;
	tableOrderLocation: Table;
}
